export default "__VITE_ASSET__sUT_K92B__"